import BottomNavMenu from './BottomNavMenuContainer';

export default BottomNavMenu;
